import React from 'react';
import { submitFormCreate, submitFormUpdate } from 'actions/library/item';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import ItemForm from './ItemForm';
import styles from './ItemDetail.css';

class ItemDetail extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.form}>
          <ItemForm
            onSubmit={this._onSubmit}
            mokapayMode={this.props.mokapayMode}
          />
        </div>
      </div>
    );
  }

  _onSubmit = values => {
    const {
      dispatch,
      items,
      search,
      salesType,
      itemDetail,
      user,
      outlets,
      file,
      customCategoriesEcommerceFashion,
    } = this.props;
    // add modifier ids value and remove active_modifiers for the api
    if (values.active_modifiers !== null) {
      values.modifier_ids = values.active_modifiers.map(am => {
        return am.id;
      });
    }

    // update updated at
    // kode ini ngikut yang di moka-rails aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L1003

    // we must delete the 'action' property so it doesn't sent to server.
    const allOutlet = values.action !== 'save';
    delete values.action;

    const inStock = [];

    values.item_variants.forEach(iv => {
      if (values.is_ecommerce) {
        // add new ecommerce attribute except color, size and material
        const customCategoriesEcommerceFashionFiltered = customCategoriesEcommerceFashion.filter(
          ({ name }) =>
            name !== 'color' &&
            name !== 'size' &&
            name !== 'material' &&
            name !== 'condition' &&
            name !== 'weight' &&
            name !== 'dimension'
        );

        // prevent duplicate field
        const filteringItemattributes =
          iv.item_variant_ecommerce_attributes &&
          iv.item_variant_ecommerce_attributes.filter(
            ({ ecommerce_attribute_name }) =>
              ecommerce_attribute_name !== 'age' &&
              ecommerce_attribute_name !== 'gender'
          );
        iv.item_variant_ecommerce_attributes = filteringItemattributes || [];

        customCategoriesEcommerceFashionFiltered.forEach(({ id, name }) => {
          const val = values[name].value;

          const tempData = {
            ecommerce_attribute_id: id,
            ecommerce_attribute_name: name,
            value: val,
          };

          iv.item_variant_ecommerce_attributes = [
            ...iv.item_variant_ecommerce_attributes,
            tempData,
          ];
        });
      }
      // PS-637 (delete in_stock to prevent overwriting) should already handled in server-side, so no need to clear the in_stock here.
      // IN-1445 and IN-1446 in_stock value should not be cleared.
      inStock.push(iv.in_stock == null ? 0 : parseInt(iv.in_stock, 10));
    });

    // if it is create, the api wants 'remote_image_url' to be sent
    if (!values.id) {
      if (values.image && values.image.url) {
        values.remote_image_url = values.image.url;
      } else {
        values.remote_image_url = '';
      }
    }
    if (!values.is_sales_type_price) {
      values.item_variants.map(itemVariant => {
        itemVariant.sales_type_items = [];
      });
    }

    if (values.id) {
      dispatch(
        submitFormUpdate(
          values.id,
          { item: values },
          allOutlet,
          items,
          salesType,
          itemDetail,
          user,
          outlets,
          search,
          inStock,
          file
        )
      );
    } else {
      // ini nambahin juga, kelupaan, emang harusnya nambahin pas create seperti di moka-rails
      // kode ini ngikut yang dev aja, di https://github.com/mokapos/moka-rails/blob/306f092dce63619cf18ab7385006f4836045159f/app/assets/javascripts/moka/services/api.js#L985
      dispatch(
        submitFormCreate(
          { item: values },
          allOutlet,
          items,
          search,
          salesType,
          user,
          outlets,
          inStock,
          file
        )
      );
    }
  };
}

function mapStateToProps(state) {
  const {
    item: { items, itemDetail, outlets, customCategoriesEcommerceFashion },
    salesType: { salesType },
  } = state.library;
  const {
    moka: { user },
  } = state;
  const { file } = state.uploadImage.uploadImage;
  return {
    items,
    itemDetail,
    search: getFormValues('search')(state),
    salesType,
    user,
    outlets,
    file,
    customCategoriesEcommerceFashion,
  };
}

ItemDetail.propTypes = {
  Item: PropTypes.object,
  dispatch: PropTypes.func,
  mokapayMode: PropTypes.bool,
};

ItemDetail.defaultProps = {
  mokapayMode: false,
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemDetail);
